import { ArrowPathIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { toast } from "react-toastify";
import { apiRequest } from "src/async/apiUtils";
import { classNames } from "src/helpers/classNames";
import { SOCIAL_MEDIA_PLATFORMS } from "src/helpers/cmsHelper";

const FooterSection = ({ site, data, newsletterData }) => {
  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [success, setSucsess] = useState(false);

  const handleSubscribeNewsLetter = async () => {
    try {
      setDisabled(true);
      await apiRequest("post", `/portal/newsletter/subscribers`, { body: { email } });
      setSucsess(true);
      setTimeout(() => {
        setEmail("");
        setSucsess(false);
      }, 1000);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setDisabled(false);
    }
  };

  return (
    <footer className={classNames(data?.hidden ? "hidden" : "relative bg-slate-900")}>
      <div className="mx-auto max-w-6xl px-6 pb-8 pt-16 md:pt-24 lg:px-8 lg:pt-32">
        <div className="lg:flex lg:items-center lg:justify-between">
          <div>
            <h3 className="text-sm font-semibold text-white">{newsletterData?.title}</h3>
            <p className="mt-2 text-sm text-slate-300">{newsletterData?.description}</p>
          </div>
          <form className="mt-6  flex gap-2 md:max-w-xl lg:mt-0">
            <label
              for="email-address"
              className="sr-only">
              Email address
            </label>
            <input
              id="email-address"
              name="email-address"
              type="email"
              required=""
              value={email}
              placeholder="Enter your email"
              autocomplete="email"
              onChange={(e) => setEmail(e.target.value)}
              className="min-w-0 flex-auto rounded-md border border-slate-300/10 bg-white/5 px-3.5 py-2 text-base leading-normal text-white !ring-0 focus:border-white md:text-sm"
            />
            <div className="flex-shrink-0">
              <button
                type="submit"
                disabled={disabled || success}
                onClick={handleSubscribeNewsLetter}
                className="flex items-center justify-center gap-2 rounded-md bg-indigo-600 px-3.5 py-4 text-sm font-semibold leading-tight text-white shadow-sm hover:bg-indigo-500">
                {newsletterData?.button_text}
                {disabled ? <ArrowPathIcon className="h-4 w-4 animate-spin stroke-2" /> : success ? <CheckCircleIcon className="h-4 w-4 stroke-2" /> : null}
              </button>
            </div>
          </form>
        </div>
        <div className="mt-8 border-t border-solid border-slate-800 pt-8 md:flex md:items-center md:justify-between">
          <div className="flex justify-center gap-x-6 sm:justify-start md:order-2">
            {data?.social_links &&
              Object.keys(data.social_links).length > 0 &&
              Object.entries(data.social_links).map(([key, href]) => {
                if (!href || !href.trim()) return null;

                const platform = SOCIAL_MEDIA_PLATFORMS.find((p) => p.key === key);
                if (!platform) return null;

                return (
                  <a
                    key={key}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-slate-400 transition-colors duration-200 hover:text-white"
                    aria-label={platform.label}>
                    {platform.icon}
                  </a>
                );
              })}
          </div>
          <p className="mt-8 text-center text-sm leading-6 text-slate-400 sm:text-left md:order-1 md:mt-0">
            &copy; {new Date().getFullYear()} {site?.site_name}, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
export default FooterSection;
